import React from 'react'

import type { SpaceProps } from '../../../../themes'
import { Rating } from '../../../Rating'
import { Container, RightContent } from './styles'

export interface CardContentReviewProps extends SpaceProps {
  className?: string
  score: number
  count: number
  rightContent?: React.ReactNode
}

export const CardContentReview = ({
  className,
  score,
  count,
  rightContent,
  ...spaceProps
}: CardContentReviewProps) => (
  <Container className={className} {...spaceProps}>
    <Rating size="sm" value={score} totalCount={count} displayValue />
    {rightContent ? <RightContent>{rightContent}</RightContent> : null}
  </Container>
)
